import { render } from "./VLTable.vue?vue&type=template&id=3c9d51fd"
import script from "./VLTable.vue?vue&type=script&lang=js"
export * from "./VLTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/sources/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__